import { LogLevel as Pt, setLogExtension as Qn, setLogLevel as Xn, RoomEvent as y, ParticipantEvent as w, Track as F, TrackEvent as Zt, getBrowser as Jn, compareVersions as Zn, Room as Ot } from "livekit-client";
import * as D from "react";
const We = Math.min, de = Math.max, Be = Math.round, Re = Math.floor, te = (e) => ({
  x: e,
  y: e
}), er = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function At(e, t, n) {
  return de(e, We(t, n));
}
function Ge(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function pe(e) {
  return e.split("-")[0];
}
function Qe(e) {
  return e.split("-")[1];
}
function en(e) {
  return e === "x" ? "y" : "x";
}
function tn(e) {
  return e === "y" ? "height" : "width";
}
function ae(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function nn(e) {
  return en(ae(e));
}
function tr(e, t, n) {
  n === void 0 && (n = !1);
  const r = Qe(e), i = nn(e), o = tn(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = je(s)), [s, je(s)];
}
function nr(e) {
  const t = je(e);
  return [ft(e), t, ft(t)];
}
function ft(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const _t = ["left", "right"], kt = ["right", "left"], rr = ["top", "bottom"], ir = ["bottom", "top"];
function or(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? kt : _t : t ? _t : kt;
    case "left":
    case "right":
      return t ? rr : ir;
    default:
      return [];
  }
}
function sr(e, t, n, r) {
  const i = Qe(e);
  let o = or(pe(e), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(ft)))), o;
}
function je(e) {
  const t = pe(e);
  return er[t] + e.slice(t.length);
}
function ar(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function cr(e) {
  return typeof e != "number" ? ar(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ve(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function Lt(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = ae(t), s = nn(t), a = tn(s), c = pe(t), u = o === "y", l = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, h = r[a] / 2 - i[a] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      d = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (Qe(t)) {
    case "start":
      d[s] -= h * (n && u ? -1 : 1);
      break;
    case "end":
      d[s] += h * (n && u ? -1 : 1);
      break;
  }
  return d;
}
async function ur(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: d = 0
  } = Ge(t, e), m = cr(d), g = a[h ? f === "floating" ? "reference" : "floating" : f], v = Ve(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(g))) == null || n ? g : g.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: l,
    strategy: c
  })), x = f === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, C = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), T = await (o.isElement == null ? void 0 : o.isElement(C)) ? await (o.getScale == null ? void 0 : o.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Ve(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: C,
    strategy: c
  }) : x);
  return {
    top: (v.top - S.top + m.top) / T.y,
    bottom: (S.bottom - v.bottom + m.bottom) / T.y,
    left: (v.left - S.left + m.left) / T.x,
    right: (S.right - v.right + m.right) / T.x
  };
}
const lr = 50, fr = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = s.detectOverflow ? s : {
    ...s,
    detectOverflow: ur
  }, c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: l,
    y: f
  } = Lt(u, r, c), h = r, d = 0;
  const m = {};
  for (let p = 0; p < o.length; p++) {
    const g = o[p];
    if (!g)
      continue;
    const {
      name: v,
      fn: x
    } = g, {
      x: C,
      y: T,
      data: S,
      reset: b
    } = await x({
      x: l,
      y: f,
      initialPlacement: r,
      placement: h,
      strategy: i,
      middlewareData: m,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    l = C ?? l, f = T ?? f, m[v] = {
      ...m[v],
      ...S
    }, b && d < lr && (d++, typeof b == "object" && (b.placement && (h = b.placement), b.rects && (u = b.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : b.rects), {
      x: l,
      y: f
    } = Lt(u, h, c)), p = -1);
  }
  return {
    x: l,
    y: f,
    placement: h,
    strategy: i,
    middlewareData: m
  };
}, dr = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: u
      } = t, {
        mainAxis: l = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: p = !0,
        ...g
      } = Ge(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const v = pe(i), x = ae(a), C = pe(a) === a, T = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), S = h || (C || !p ? [je(a)] : nr(a)), b = m !== "none";
      !h && b && S.push(...sr(a, p, m, T));
      const P = [a, ...S], R = await c.detectOverflow(t, g), M = [];
      let W = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (l && M.push(R[v]), f) {
        const k = tr(i, s, T);
        M.push(R[k[0]], R[k[1]]);
      }
      if (W = [...W, {
        placement: i,
        overflows: M
      }], !M.every((k) => k <= 0)) {
        var E, O;
        const k = (((E = o.flip) == null ? void 0 : E.index) || 0) + 1, $ = P[k];
        if ($ && (!(f === "alignment" ? x !== ae($) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        W.every((N) => ae(N.placement) === x ? N.overflows[0] > 0 : !0)))
          return {
            data: {
              index: k,
              overflows: W
            },
            reset: {
              placement: $
            }
          };
        let G = (O = W.filter((X) => X.overflows[0] <= 0).sort((X, N) => X.overflows[1] - N.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!G)
          switch (d) {
            case "bestFit": {
              var j;
              const X = (j = W.filter((N) => {
                if (b) {
                  const se = ae(N.placement);
                  return se === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  se === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((se) => se > 0).reduce((se, Gn) => se + Gn, 0)]).sort((N, se) => N[1] - se[1])[0]) == null ? void 0 : j[0];
              X && (G = X);
              break;
            }
            case "initialPlacement":
              G = a;
              break;
          }
        if (i !== G)
          return {
            reset: {
              placement: G
            }
          };
      }
      return {};
    }
  };
}, pr = /* @__PURE__ */ new Set(["left", "top"]);
async function hr(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = pe(n), a = Qe(n), c = ae(n) === "y", u = pr.has(s) ? -1 : 1, l = o && c ? -1 : 1, f = Ge(t, e);
  let {
    mainAxis: h,
    crossAxis: d,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof m == "number" && (d = a === "end" ? m * -1 : m), c ? {
    x: d * l,
    y: h * u
  } : {
    x: h * u,
    y: d * l
  };
}
const vr = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = t, c = await hr(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, mr = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        platform: o
      } = t, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: c = {
          fn: (v) => {
            let {
              x,
              y: C
            } = v;
            return {
              x,
              y: C
            };
          }
        },
        ...u
      } = Ge(e, t), l = {
        x: n,
        y: r
      }, f = await o.detectOverflow(t, u), h = ae(pe(i)), d = en(h);
      let m = l[d], p = l[h];
      if (s) {
        const v = d === "y" ? "top" : "left", x = d === "y" ? "bottom" : "right", C = m + f[v], T = m - f[x];
        m = At(C, m, T);
      }
      if (a) {
        const v = h === "y" ? "top" : "left", x = h === "y" ? "bottom" : "right", C = p + f[v], T = p - f[x];
        p = At(C, p, T);
      }
      const g = c.fn({
        ...t,
        [d]: m,
        [h]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [d]: s,
            [h]: a
          }
        }
      };
    }
  };
};
function Xe() {
  return typeof window < "u";
}
function Ce(e) {
  return rn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function K(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ne(e) {
  var t;
  return (t = (rn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function rn(e) {
  return Xe() ? e instanceof Node || e instanceof K(e).Node : !1;
}
function Z(e) {
  return Xe() ? e instanceof Element || e instanceof K(e).Element : !1;
}
function ie(e) {
  return Xe() ? e instanceof HTMLElement || e instanceof K(e).HTMLElement : !1;
}
function It(e) {
  return !Xe() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof K(e).ShadowRoot;
}
function Le(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = ee(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function gr(e) {
  return /^(table|td|th)$/.test(Ce(e));
}
function Je(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const br = /transform|translate|scale|rotate|perspective|filter/, yr = /paint|layout|strict|content/, le = (e) => !!e && e !== "none";
let it;
function bt(e) {
  const t = Z(e) ? ee(e) : e;
  return le(t.transform) || le(t.translate) || le(t.scale) || le(t.rotate) || le(t.perspective) || !yt() && (le(t.backdropFilter) || le(t.filter)) || br.test(t.willChange || "") || yr.test(t.contain || "");
}
function wr(e) {
  let t = ue(e);
  for (; ie(t) && !we(t); ) {
    if (bt(t))
      return t;
    if (Je(t))
      return null;
    t = ue(t);
  }
  return null;
}
function yt() {
  return it == null && (it = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), it;
}
function we(e) {
  return /^(html|body|#document)$/.test(Ce(e));
}
function ee(e) {
  return K(e).getComputedStyle(e);
}
function Ze(e) {
  return Z(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ue(e) {
  if (Ce(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    It(e) && e.host || // Fallback.
    ne(e)
  );
  return It(t) ? t.host : t;
}
function on(e) {
  const t = ue(e);
  return we(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ie(t) && Le(t) ? t : on(t);
}
function Oe(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = on(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), s = K(i);
  if (o) {
    const a = dt(s);
    return t.concat(s, s.visualViewport || [], Le(i) ? i : [], a && n ? Oe(a) : []);
  } else
    return t.concat(i, Oe(i, [], n));
}
function dt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function sn(e) {
  const t = ee(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = ie(e), o = i ? e.offsetWidth : n, s = i ? e.offsetHeight : r, a = Be(n) !== o || Be(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function wt(e) {
  return Z(e) ? e : e.contextElement;
}
function ge(e) {
  const t = wt(e);
  if (!ie(t))
    return te(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = sn(t);
  let s = (o ? Be(n.width) : n.width) / r, a = (o ? Be(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const xr = /* @__PURE__ */ te(0);
function an(e) {
  const t = K(e);
  return !yt() || !t.visualViewport ? xr : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Sr(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== K(e) ? !1 : t;
}
function he(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = wt(e);
  let s = te(1);
  t && (r ? Z(r) && (s = ge(r)) : s = ge(e));
  const a = Sr(o, n, r) ? an(o) : te(0);
  let c = (i.left + a.x) / s.x, u = (i.top + a.y) / s.y, l = i.width / s.x, f = i.height / s.y;
  if (o) {
    const h = K(o), d = r && Z(r) ? K(r) : r;
    let m = h, p = dt(m);
    for (; p && r && d !== m; ) {
      const g = ge(p), v = p.getBoundingClientRect(), x = ee(p), C = v.left + (p.clientLeft + parseFloat(x.paddingLeft)) * g.x, T = v.top + (p.clientTop + parseFloat(x.paddingTop)) * g.y;
      c *= g.x, u *= g.y, l *= g.x, f *= g.y, c += C, u += T, m = K(p), p = dt(m);
    }
  }
  return Ve({
    width: l,
    height: f,
    x: c,
    y: u
  });
}
function et(e, t) {
  const n = Ze(e).scrollLeft;
  return t ? t.left + n : he(ne(e)).left + n;
}
function cn(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - et(e, n), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function Cr(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", s = ne(r), a = t ? Je(t.floating) : !1;
  if (r === s || a && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = te(1);
  const l = te(0), f = ie(r);
  if ((f || !f && !o) && ((Ce(r) !== "body" || Le(s)) && (c = Ze(r)), f)) {
    const d = he(r);
    u = ge(r), l.x = d.x + r.clientLeft, l.y = d.y + r.clientTop;
  }
  const h = s && !f && !o ? cn(s, c) : te(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + l.x + h.x,
    y: n.y * u.y - c.scrollTop * u.y + l.y + h.y
  };
}
function Er(e) {
  return Array.from(e.getClientRects());
}
function Tr(e) {
  const t = ne(e), n = Ze(e), r = e.ownerDocument.body, i = de(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = de(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + et(e);
  const a = -n.scrollTop;
  return ee(r).direction === "rtl" && (s += de(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
const Rt = 25;
function Pr(e, t) {
  const n = K(e), r = ne(e), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const l = yt();
    (!l || l && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  const u = et(r);
  if (u <= 0) {
    const l = r.ownerDocument, f = l.body, h = getComputedStyle(f), d = l.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, m = Math.abs(r.clientWidth - f.clientWidth - d);
    m <= Rt && (o -= m);
  } else u <= Rt && (o += u);
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
function Or(e, t) {
  const n = he(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = ie(e) ? ge(e) : te(1), s = e.clientWidth * o.x, a = e.clientHeight * o.y, c = i * o.x, u = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: u
  };
}
function Mt(e, t, n) {
  let r;
  if (t === "viewport")
    r = Pr(e, n);
  else if (t === "document")
    r = Tr(ne(e));
  else if (Z(t))
    r = Or(t, n);
  else {
    const i = an(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Ve(r);
}
function un(e, t) {
  const n = ue(e);
  return n === t || !Z(n) || we(n) ? !1 : ee(n).position === "fixed" || un(n, t);
}
function Ar(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Oe(e, [], !1).filter((a) => Z(a) && Ce(a) !== "body"), i = null;
  const o = ee(e).position === "fixed";
  let s = o ? ue(e) : e;
  for (; Z(s) && !we(s); ) {
    const a = ee(s), c = bt(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && (i.position === "absolute" || i.position === "fixed") || Le(s) && !c && un(e, s)) ? r = r.filter((l) => l !== s) : i = a, s = ue(s);
  }
  return t.set(e, r), r;
}
function _r(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? Je(t) ? [] : Ar(t, this._c) : [].concat(n), r], a = Mt(t, s[0], i);
  let c = a.top, u = a.right, l = a.bottom, f = a.left;
  for (let h = 1; h < s.length; h++) {
    const d = Mt(t, s[h], i);
    c = de(d.top, c), u = We(d.right, u), l = We(d.bottom, l), f = de(d.left, f);
  }
  return {
    width: u - f,
    height: l - c,
    x: f,
    y: c
  };
}
function kr(e) {
  const {
    width: t,
    height: n
  } = sn(e);
  return {
    width: t,
    height: n
  };
}
function Lr(e, t, n) {
  const r = ie(t), i = ne(t), o = n === "fixed", s = he(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = te(0);
  function u() {
    c.x = et(i);
  }
  if (r || !r && !o)
    if ((Ce(t) !== "body" || Le(i)) && (a = Ze(t)), r) {
      const d = he(t, !0, o, t);
      c.x = d.x + t.clientLeft, c.y = d.y + t.clientTop;
    } else i && u();
  o && !r && i && u();
  const l = i && !r && !o ? cn(i, a) : te(0), f = s.left + a.scrollLeft - c.x - l.x, h = s.top + a.scrollTop - c.y - l.y;
  return {
    x: f,
    y: h,
    width: s.width,
    height: s.height
  };
}
function ot(e) {
  return ee(e).position === "static";
}
function Dt(e, t) {
  if (!ie(e) || ee(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ne(e) === n && (n = n.ownerDocument.body), n;
}
function ln(e, t) {
  const n = K(e);
  if (Je(e))
    return n;
  if (!ie(e)) {
    let i = ue(e);
    for (; i && !we(i); ) {
      if (Z(i) && !ot(i))
        return i;
      i = ue(i);
    }
    return n;
  }
  let r = Dt(e, t);
  for (; r && gr(r) && ot(r); )
    r = Dt(r, t);
  return r && we(r) && ot(r) && !bt(r) ? n : r || wr(e) || n;
}
const Ir = async function(e) {
  const t = this.getOffsetParent || ln, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Lr(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Rr(e) {
  return ee(e).direction === "rtl";
}
const Mr = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Cr,
  getDocumentElement: ne,
  getClippingRect: _r,
  getOffsetParent: ln,
  getElementRects: Ir,
  getClientRects: Er,
  getDimensions: kr,
  getScale: ge,
  isElement: Z,
  isRTL: Rr
};
function fn(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Dr(e, t) {
  let n = null, r;
  const i = ne(e);
  function o() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), o();
    const u = e.getBoundingClientRect(), {
      left: l,
      top: f,
      width: h,
      height: d
    } = u;
    if (a || t(), !h || !d)
      return;
    const m = Re(f), p = Re(i.clientWidth - (l + h)), g = Re(i.clientHeight - (f + d)), v = Re(l), C = {
      rootMargin: -m + "px " + -p + "px " + -g + "px " + -v + "px",
      threshold: de(0, We(1, c)) || 1
    };
    let T = !0;
    function S(b) {
      const P = b[0].intersectionRatio;
      if (P !== c) {
        if (!T)
          return s();
        P ? s(!1, P) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !fn(u, e.getBoundingClientRect()) && s(), T = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...C,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, C);
    }
    n.observe(e);
  }
  return s(!0), o;
}
function $r(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = wt(e), l = i || o ? [...u ? Oe(u) : [], ...t ? Oe(t) : []] : [];
  l.forEach((v) => {
    i && v.addEventListener("scroll", n, {
      passive: !0
    }), o && v.addEventListener("resize", n);
  });
  const f = u && a ? Dr(u, n) : null;
  let h = -1, d = null;
  s && (d = new ResizeObserver((v) => {
    let [x] = v;
    x && x.target === u && d && t && (d.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var C;
      (C = d) == null || C.observe(t);
    })), n();
  }), u && !c && d.observe(u), t && d.observe(t));
  let m, p = c ? he(e) : null;
  c && g();
  function g() {
    const v = he(e);
    p && !fn(p, v) && n(), p = v, m = requestAnimationFrame(g);
  }
  return n(), () => {
    var v;
    l.forEach((x) => {
      i && x.removeEventListener("scroll", n), o && x.removeEventListener("resize", n);
    }), f?.(), (v = d) == null || v.disconnect(), d = null, c && cancelAnimationFrame(m);
  };
}
const Nr = vr, Fr = mr, Ur = dr, Wr = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Mr,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return fr(e, t, {
    ...i,
    platform: o
  });
};
var es = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Br(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ne = { exports: {} }, jr = Ne.exports, $t;
function Vr() {
  return $t || ($t = 1, (function(e) {
    (function(t, n) {
      e.exports ? e.exports = n() : t.log = n();
    })(jr, function() {
      var t = function() {
      }, n = "undefined", r = typeof window !== n && typeof window.navigator !== n && /Trident\/|MSIE /.test(window.navigator.userAgent), i = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], o = {}, s = null;
      function a(p, g) {
        var v = p[g];
        if (typeof v.bind == "function")
          return v.bind(p);
        try {
          return Function.prototype.bind.call(v, p);
        } catch {
          return function() {
            return Function.prototype.apply.apply(v, [p, arguments]);
          };
        }
      }
      function c() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function u(p) {
        return p === "debug" && (p = "log"), typeof console === n ? !1 : p === "trace" && r ? c : console[p] !== void 0 ? a(console, p) : console.log !== void 0 ? a(console, "log") : t;
      }
      function l() {
        for (var p = this.getLevel(), g = 0; g < i.length; g++) {
          var v = i[g];
          this[v] = g < p ? t : this.methodFactory(v, p, this.name);
        }
        if (this.log = this.debug, typeof console === n && p < this.levels.SILENT)
          return "No console available for logging";
      }
      function f(p) {
        return function() {
          typeof console !== n && (l.call(this), this[p].apply(this, arguments));
        };
      }
      function h(p, g, v) {
        return u(p) || f.apply(this, arguments);
      }
      function d(p, g) {
        var v = this, x, C, T, S = "loglevel";
        typeof p == "string" ? S += ":" + p : typeof p == "symbol" && (S = void 0);
        function b(E) {
          var O = (i[E] || "silent").toUpperCase();
          if (!(typeof window === n || !S)) {
            try {
              window.localStorage[S] = O;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(S) + "=" + O + ";";
            } catch {
            }
          }
        }
        function P() {
          var E;
          if (!(typeof window === n || !S)) {
            try {
              E = window.localStorage[S];
            } catch {
            }
            if (typeof E === n)
              try {
                var O = window.document.cookie, j = encodeURIComponent(S), k = O.indexOf(j + "=");
                k !== -1 && (E = /^([^;]+)/.exec(
                  O.slice(k + j.length + 1)
                )[1]);
              } catch {
              }
            return v.levels[E] === void 0 && (E = void 0), E;
          }
        }
        function R() {
          if (!(typeof window === n || !S)) {
            try {
              window.localStorage.removeItem(S);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(S) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function M(E) {
          var O = E;
          if (typeof O == "string" && v.levels[O.toUpperCase()] !== void 0 && (O = v.levels[O.toUpperCase()]), typeof O == "number" && O >= 0 && O <= v.levels.SILENT)
            return O;
          throw new TypeError("log.setLevel() called with invalid level: " + E);
        }
        v.name = p, v.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, v.methodFactory = g || h, v.getLevel = function() {
          return T ?? C ?? x;
        }, v.setLevel = function(E, O) {
          return T = M(E), O !== !1 && b(T), l.call(v);
        }, v.setDefaultLevel = function(E) {
          C = M(E), P() || v.setLevel(E, !1);
        }, v.resetLevel = function() {
          T = null, R(), l.call(v);
        }, v.enableAll = function(E) {
          v.setLevel(v.levels.TRACE, E);
        }, v.disableAll = function(E) {
          v.setLevel(v.levels.SILENT, E);
        }, v.rebuild = function() {
          if (s !== v && (x = M(s.getLevel())), l.call(v), s === v)
            for (var E in o)
              o[E].rebuild();
        }, x = M(
          s ? s.getLevel() : "WARN"
        );
        var W = P();
        W != null && (T = M(W)), l.call(v);
      }
      s = new d(), s.getLogger = function(g) {
        if (typeof g != "symbol" && typeof g != "string" || g === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var v = o[g];
        return v || (v = o[g] = new d(
          g,
          s.methodFactory
        )), v;
      };
      var m = typeof window !== n ? window.log : void 0;
      return s.noConflict = function() {
        return typeof window !== n && window.log === s && (window.log = m), s;
      }, s.getLoggers = function() {
        return o;
      }, s.default = s, s;
    });
  })(Ne)), Ne.exports;
}
var Hr = Vr();
const zr = /* @__PURE__ */ Br(Hr);
var pt = function(e, t) {
  return pt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, pt(e, t);
};
function oe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  pt(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function Yr(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function a(l) {
      try {
        u(r.next(l));
      } catch (f) {
        s(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        s(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(a, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function dn(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s.next = a(0), s.throw = a(1), s.return = a(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function xe(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ve(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function Se(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function be(e) {
  return this instanceof be ? (this.v = e, this) : new be(e);
}
function Kr(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, o = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", s), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function s(d) {
    return function(m) {
      return Promise.resolve(m).then(d, f);
    };
  }
  function a(d, m) {
    r[d] && (i[d] = function(p) {
      return new Promise(function(g, v) {
        o.push([d, p, g, v]) > 1 || c(d, p);
      });
    }, m && (i[d] = m(i[d])));
  }
  function c(d, m) {
    try {
      u(r[d](m));
    } catch (p) {
      h(o[0][3], p);
    }
  }
  function u(d) {
    d.value instanceof be ? Promise.resolve(d.value.v).then(l, f) : h(o[0][2], d);
  }
  function l(d) {
    c("next", d);
  }
  function f(d) {
    c("throw", d);
  }
  function h(d, m) {
    d(m), o.shift(), o.length && c(o[0][0], o[0][1]);
  }
}
function qr(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof xe == "function" ? xe(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = e[o] && function(s) {
      return new Promise(function(a, c) {
        s = e[o](s), i(a, c, s.done, s.value);
      });
    };
  }
  function i(o, s, a, c) {
    Promise.resolve(c).then(function(u) {
      o({ value: u, done: a });
    }, s);
  }
}
function A(e) {
  return typeof e == "function";
}
function xt(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var st = xt(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function He(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var Ie = (function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, i, o;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var a = xe(s), c = a.next(); !c.done; c = a.next()) {
              var u = c.value;
              u.remove(this);
            }
          } catch (p) {
            t = { error: p };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
        else
          s.remove(this);
      var l = this.initialTeardown;
      if (A(l))
        try {
          l();
        } catch (p) {
          o = p instanceof st ? p.errors : [p];
        }
      var f = this._finalizers;
      if (f) {
        this._finalizers = null;
        try {
          for (var h = xe(f), d = h.next(); !d.done; d = h.next()) {
            var m = d.value;
            try {
              Nt(m);
            } catch (p) {
              o = o ?? [], p instanceof st ? o = Se(Se([], ve(o)), ve(p.errors)) : o.push(p);
            }
          }
        } catch (p) {
          r = { error: p };
        } finally {
          try {
            d && !d.done && (i = h.return) && i.call(h);
          } finally {
            if (r) throw r.error;
          }
        }
      }
      if (o)
        throw new st(o);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        Nt(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && He(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && He(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = (function() {
    var t = new e();
    return t.closed = !0, t;
  })(), e;
})(), pn = Ie.EMPTY;
function hn(e) {
  return e instanceof Ie || e && "closed" in e && A(e.remove) && A(e.add) && A(e.unsubscribe);
}
function Nt(e) {
  A(e) ? e() : e.unsubscribe();
}
var Gr = {
  Promise: void 0
}, Qr = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, Se([e, t], ve(n)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function vn(e) {
  Qr.setTimeout(function() {
    throw e;
  });
}
function ze() {
}
function Fe(e) {
  e();
}
var St = (function(e) {
  oe(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, hn(n) && n.add(r)) : r.destination = Zr, r;
  }
  return t.create = function(n, r, i) {
    return new Ae(n, r, i);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
})(Ie), Xr = (function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        Me(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        Me(r);
      }
    else
      Me(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        Me(n);
      }
  }, e;
})(), Ae = (function(e) {
  oe(t, e);
  function t(n, r, i) {
    var o = e.call(this) || this, s;
    return A(n) || !n ? s = {
      next: n ?? void 0,
      error: r ?? void 0,
      complete: i ?? void 0
    } : s = n, o.destination = new Xr(s), o;
  }
  return t;
})(St);
function Me(e) {
  vn(e);
}
function Jr(e) {
  throw e;
}
var Zr = {
  closed: !0,
  next: ze,
  error: Jr,
  complete: ze
}, Ct = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})();
function tt(e) {
  return e;
}
function ei(e) {
  return e.length === 0 ? tt : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, i) {
      return i(r);
    }, n);
  };
}
var L = (function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var i = this, o = ni(t) ? t : new Ae(t, n, r);
    return Fe(function() {
      var s = i, a = s.operator, c = s.source;
      o.add(a ? a.call(o, c) : c ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = Ft(n), new n(function(i, o) {
      var s = new Ae({
        next: function(a) {
          try {
            t(a);
          } catch (c) {
            o(c), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      r.subscribe(s);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[Ct] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return ei(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = Ft(t), new t(function(r, i) {
      var o;
      n.subscribe(function(s) {
        return o = s;
      }, function(s) {
        return i(s);
      }, function() {
        return r(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
})();
function Ft(e) {
  var t;
  return (t = e ?? Gr.Promise) !== null && t !== void 0 ? t : Promise;
}
function ti(e) {
  return e && A(e.next) && A(e.error) && A(e.complete);
}
function ni(e) {
  return e && e instanceof St || ti(e) && hn(e);
}
function ri(e) {
  return A(e?.lift);
}
function B(e) {
  return function(t) {
    if (ri(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function z(e, t, n, r, i) {
  return new ii(e, t, n, r, i);
}
var ii = (function(e) {
  oe(t, e);
  function t(n, r, i, o, s, a) {
    var c = e.call(this, n) || this;
    return c.onFinalize = s, c.shouldUnsubscribe = a, c._next = r ? function(u) {
      try {
        r(u);
      } catch (l) {
        n.error(l);
      }
    } : e.prototype._next, c._error = o ? function(u) {
      try {
        o(u);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, c._complete = i ? function() {
      try {
        i();
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, c;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
})(St), oi = xt(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), re = (function(e) {
  oe(t, e);
  function t() {
    var n = e.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return t.prototype.lift = function(n) {
    var r = new Ut(this, this);
    return r.operator = n, r;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new oi();
  }, t.prototype.next = function(n) {
    var r = this;
    Fe(function() {
      var i, o;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var s = xe(r.currentObservers), a = s.next(); !a.done; a = s.next()) {
            var c = a.value;
            c.next(n);
          }
        } catch (u) {
          i = { error: u };
        } finally {
          try {
            a && !a.done && (o = s.return) && o.call(s);
          } finally {
            if (i) throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(n) {
    var r = this;
    Fe(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var i = r.observers; i.length; )
          i.shift().error(n);
      }
    });
  }, t.prototype.complete = function() {
    var n = this;
    Fe(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, n);
  }, t.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, t.prototype._innerSubscribe = function(n) {
    var r = this, i = this, o = i.hasError, s = i.isStopped, a = i.observers;
    return o || s ? pn : (this.currentObservers = null, a.push(n), new Ie(function() {
      r.currentObservers = null, He(a, n);
    }));
  }, t.prototype._checkFinalizedStatuses = function(n) {
    var r = this, i = r.hasError, o = r.thrownError, s = r.isStopped;
    i ? n.error(o) : s && n.complete();
  }, t.prototype.asObservable = function() {
    var n = new L();
    return n.source = this, n;
  }, t.create = function(n, r) {
    return new Ut(n, r);
  }, t;
})(L), Ut = (function(e) {
  oe(t, e);
  function t(n, r) {
    var i = e.call(this) || this;
    return i.destination = n, i.source = r, i;
  }
  return t.prototype.next = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || i === void 0 || i.call(r, n);
  }, t.prototype.error = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || i === void 0 || i.call(r, n);
  }, t.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, t.prototype._subscribe = function(n) {
    var r, i;
    return (i = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && i !== void 0 ? i : pn;
  }, t;
})(re), mn = (function(e) {
  oe(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r._value = n, r;
  }
  return Object.defineProperty(t.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._subscribe = function(n) {
    var r = e.prototype._subscribe.call(this, n);
    return !r.closed && n.next(this._value), r;
  }, t.prototype.getValue = function() {
    var n = this, r = n.hasError, i = n.thrownError, o = n._value;
    if (r)
      throw i;
    return this._throwIfClosed(), o;
  }, t.prototype.next = function(n) {
    e.prototype.next.call(this, this._value = n);
  }, t;
})(re), si = {
  now: function() {
    return Date.now();
  }
}, ai = (function(e) {
  oe(t, e);
  function t(n, r) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(n, r) {
    return this;
  }, t;
})(Ie), Wt = {
  setInterval: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setInterval.apply(void 0, Se([e, t], ve(n)));
  },
  clearInterval: function(e) {
    return clearInterval(e);
  },
  delegate: void 0
}, ci = (function(e) {
  oe(t, e);
  function t(n, r) {
    var i = e.call(this, n, r) || this;
    return i.scheduler = n, i.work = r, i.pending = !1, i;
  }
  return t.prototype.schedule = function(n, r) {
    var i;
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = n;
    var o = this.id, s = this.scheduler;
    return o != null && (this.id = this.recycleAsyncId(s, o, r)), this.pending = !0, this.delay = r, this.id = (i = this.id) !== null && i !== void 0 ? i : this.requestAsyncId(s, this.id, r), this;
  }, t.prototype.requestAsyncId = function(n, r, i) {
    return i === void 0 && (i = 0), Wt.setInterval(n.flush.bind(n, this), i);
  }, t.prototype.recycleAsyncId = function(n, r, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return r;
    r != null && Wt.clearInterval(r);
  }, t.prototype.execute = function(n, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(n, r);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(n, r) {
    var i = !1, o;
    try {
      this.work(n);
    } catch (s) {
      i = !0, o = s || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), o;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, r = n.id, i = n.scheduler, o = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, He(o, this), r != null && (this.id = this.recycleAsyncId(i, r, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
})(ai), Bt = (function() {
  function e(t, n) {
    n === void 0 && (n = e.now), this.schedulerActionCtor = t, this.now = n;
  }
  return e.prototype.schedule = function(t, n, r) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, t).schedule(r, n);
  }, e.now = si.now, e;
})(), ui = (function(e) {
  oe(t, e);
  function t(n, r) {
    r === void 0 && (r = Bt.now);
    var i = e.call(this, n, r) || this;
    return i.actions = [], i._active = !1, i;
  }
  return t.prototype.flush = function(n) {
    var r = this.actions;
    if (this._active) {
      r.push(n);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = n.execute(n.state, n.delay))
        break;
    while (n = r.shift());
    if (this._active = !1, i) {
      for (; n = r.shift(); )
        n.unsubscribe();
      throw i;
    }
  }, t;
})(Bt), li = new ui(ci);
function fi(e) {
  return e && A(e.schedule);
}
function di(e) {
  return e[e.length - 1];
}
function Et(e) {
  return fi(di(e)) ? e.pop() : void 0;
}
var Tt = (function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
});
function gn(e) {
  return A(e?.then);
}
function bn(e) {
  return A(e[Ct]);
}
function yn(e) {
  return Symbol.asyncIterator && A(e?.[Symbol.asyncIterator]);
}
function wn(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function pi() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var xn = pi();
function Sn(e) {
  return A(e?.[xn]);
}
function Cn(e) {
  return Kr(this, arguments, function() {
    var n, r, i, o;
    return dn(this, function(s) {
      switch (s.label) {
        case 0:
          n = e.getReader(), s.label = 1;
        case 1:
          s.trys.push([1, , 9, 10]), s.label = 2;
        case 2:
          return [4, be(n.read())];
        case 3:
          return r = s.sent(), i = r.value, o = r.done, o ? [4, be(void 0)] : [3, 5];
        case 4:
          return [2, s.sent()];
        case 5:
          return [4, be(i)];
        case 6:
          return [4, s.sent()];
        case 7:
          return s.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function En(e) {
  return A(e?.getReader);
}
function Q(e) {
  if (e instanceof L)
    return e;
  if (e != null) {
    if (bn(e))
      return hi(e);
    if (Tt(e))
      return vi(e);
    if (gn(e))
      return mi(e);
    if (yn(e))
      return Tn(e);
    if (Sn(e))
      return gi(e);
    if (En(e))
      return bi(e);
  }
  throw wn(e);
}
function hi(e) {
  return new L(function(t) {
    var n = e[Ct]();
    if (A(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function vi(e) {
  return new L(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function mi(e) {
  return new L(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, vn);
  });
}
function gi(e) {
  return new L(function(t) {
    var n, r;
    try {
      for (var i = xe(e), o = i.next(); !o.done; o = i.next()) {
        var s = o.value;
        if (t.next(s), t.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        o && !o.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    t.complete();
  });
}
function Tn(e) {
  return new L(function(t) {
    yi(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function bi(e) {
  return Tn(Cn(e));
}
function yi(e, t) {
  var n, r, i, o;
  return Yr(this, void 0, void 0, function() {
    var s, a;
    return dn(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), n = qr(e), c.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = c.sent(), !!r.done) return [3, 4];
          if (s = r.value, t.next(s), t.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = c.sent(), i = { error: a }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), r && !r.done && (o = n.return) ? [4, o.call(n)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i) throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function ce(e, t, n, r, i) {
  r === void 0 && (r = 0), i === void 0 && (i = !1);
  var o = t.schedule(function() {
    n(), i ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(o), !i)
    return o;
}
function Pn(e, t) {
  return t === void 0 && (t = 0), B(function(n, r) {
    n.subscribe(z(r, function(i) {
      return ce(r, e, function() {
        return r.next(i);
      }, t);
    }, function() {
      return ce(r, e, function() {
        return r.complete();
      }, t);
    }, function(i) {
      return ce(r, e, function() {
        return r.error(i);
      }, t);
    }));
  });
}
function On(e, t) {
  return t === void 0 && (t = 0), B(function(n, r) {
    r.add(e.schedule(function() {
      return n.subscribe(r);
    }, t));
  });
}
function wi(e, t) {
  return Q(e).pipe(On(t), Pn(t));
}
function xi(e, t) {
  return Q(e).pipe(On(t), Pn(t));
}
function Si(e, t) {
  return new L(function(n) {
    var r = 0;
    return t.schedule(function() {
      r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
    });
  });
}
function Ci(e, t) {
  return new L(function(n) {
    var r;
    return ce(n, t, function() {
      r = e[xn](), ce(n, t, function() {
        var i, o, s;
        try {
          i = r.next(), o = i.value, s = i.done;
        } catch (a) {
          n.error(a);
          return;
        }
        s ? n.complete() : n.next(o);
      }, 0, !0);
    }), function() {
      return A(r?.return) && r.return();
    };
  });
}
function An(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new L(function(n) {
    ce(n, t, function() {
      var r = e[Symbol.asyncIterator]();
      ce(n, t, function() {
        r.next().then(function(i) {
          i.done ? n.complete() : n.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function Ei(e, t) {
  return An(Cn(e), t);
}
function Ti(e, t) {
  if (e != null) {
    if (bn(e))
      return wi(e, t);
    if (Tt(e))
      return Si(e, t);
    if (gn(e))
      return xi(e, t);
    if (yn(e))
      return An(e, t);
    if (Sn(e))
      return Ci(e, t);
    if (En(e))
      return Ei(e, t);
  }
  throw wn(e);
}
function ye(e, t) {
  return t ? Ti(e, t) : Q(e);
}
function ht() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = Et(e);
  return ye(e, n);
}
function Pi(e) {
  return e instanceof Date && !isNaN(e);
}
var Oi = xt(function(e) {
  return function(n) {
    n === void 0 && (n = null), e(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = n;
  };
});
function Ai(e, t) {
  var n = Pi(e) ? { first: e } : typeof e == "number" ? { each: e } : e, r = n.first, i = n.each, o = n.with, s = o === void 0 ? _i : o, a = n.scheduler, c = a === void 0 ? li : a, u = n.meta, l = u === void 0 ? null : u;
  if (r == null && i == null)
    throw new TypeError("No timeout provided.");
  return B(function(f, h) {
    var d, m, p = null, g = 0, v = function(x) {
      m = ce(h, c, function() {
        try {
          d.unsubscribe(), Q(s({
            meta: l,
            lastValue: p,
            seen: g
          })).subscribe(h);
        } catch (C) {
          h.error(C);
        }
      }, x);
    };
    d = f.subscribe(z(h, function(x) {
      m?.unsubscribe(), g++, h.next(p = x), i > 0 && v(i);
    }, void 0, void 0, function() {
      m?.closed || m?.unsubscribe(), p = null;
    })), !g && v(r != null ? typeof r == "number" ? r : +r - c.now() : i);
  });
}
function _i(e) {
  throw new Oi(e);
}
function _(e, t) {
  return B(function(n, r) {
    var i = 0;
    n.subscribe(z(r, function(o) {
      r.next(e.call(t, o, i++));
    }));
  });
}
var ki = Array.isArray;
function Li(e, t) {
  return ki(t) ? e.apply(void 0, Se([], ve(t))) : e(t);
}
function Ii(e) {
  return _(function(t) {
    return Li(e, t);
  });
}
function Ri(e, t, n, r, i, o, s, a) {
  var c = [], u = 0, l = 0, f = !1, h = function() {
    f && !c.length && !u && t.complete();
  }, d = function(p) {
    return u < r ? m(p) : c.push(p);
  }, m = function(p) {
    u++;
    var g = !1;
    Q(n(p, l++)).subscribe(z(t, function(v) {
      t.next(v);
    }, function() {
      g = !0;
    }, void 0, function() {
      if (g)
        try {
          u--;
          for (var v = function() {
            var x = c.shift();
            s || m(x);
          }; c.length && u < r; )
            v();
          h();
        } catch (x) {
          t.error(x);
        }
    }));
  };
  return e.subscribe(z(t, d, function() {
    f = !0, h();
  })), function() {
  };
}
function _e(e, t, n) {
  return n === void 0 && (n = 1 / 0), A(t) ? _e(function(r, i) {
    return _(function(o, s) {
      return t(r, o, i, s);
    })(Q(e(r, i)));
  }, n) : (typeof t == "number" && (n = t), B(function(r, i) {
    return Ri(r, i, e, n);
  }));
}
function Mi(e) {
  return _e(tt, e);
}
function Di() {
  return Mi(1);
}
function Ye() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Di()(ye(e, Et(e)));
}
var $i = ["addListener", "removeListener"], Ni = ["addEventListener", "removeEventListener"], Fi = ["on", "off"];
function vt(e, t, n, r) {
  if (A(n) && (r = n, n = void 0), r)
    return vt(e, t, n).pipe(Ii(r));
  var i = ve(Bi(e) ? Ni.map(function(a) {
    return function(c) {
      return e[a](t, c, n);
    };
  }) : Ui(e) ? $i.map(jt(e, t)) : Wi(e) ? Fi.map(jt(e, t)) : [], 2), o = i[0], s = i[1];
  if (!o && Tt(e))
    return _e(function(a) {
      return vt(a, t, n);
    })(Q(e));
  if (!o)
    throw new TypeError("Invalid event target");
  return new L(function(a) {
    var c = function() {
      for (var u = [], l = 0; l < arguments.length; l++)
        u[l] = arguments[l];
      return a.next(1 < u.length ? u : u[0]);
    };
    return o(c), function() {
      return s(c);
    };
  });
}
function jt(e, t) {
  return function(n) {
    return function(r) {
      return e[n](t, r);
    };
  };
}
function Ui(e) {
  return A(e.addListener) && A(e.removeListener);
}
function Wi(e) {
  return A(e.on) && A(e.off);
}
function Bi(e) {
  return A(e.addEventListener) && A(e.removeEventListener);
}
function nt(e, t) {
  return B(function(n, r) {
    var i = 0;
    n.subscribe(z(r, function(o) {
      return e.call(t, o, i++) && r.next(o);
    }));
  });
}
function ji(e, t, n, r, i) {
  return function(o, s) {
    var a = n, c = t, u = 0;
    o.subscribe(z(s, function(l) {
      var f = u++;
      c = a ? e(c, l, f) : (a = !0, l), s.next(c);
    }, i));
  };
}
function Vi(e, t) {
  return t === void 0 && (t = tt), e = e ?? Hi, B(function(n, r) {
    var i, o = !0;
    n.subscribe(z(r, function(s) {
      var a = t(s);
      (o || !e(i, a)) && (o = !1, i = a, r.next(s));
    }));
  });
}
function Hi(e, t) {
  return e === t;
}
function zi(e) {
  return B(function(t, n) {
    try {
      t.subscribe(n);
    } finally {
      n.add(e);
    }
  });
}
function Ue(e, t) {
  return B(ji(e, t, arguments.length >= 2, !0));
}
function Yi(e) {
  e === void 0 && (e = {});
  var t = e.connector, n = t === void 0 ? function() {
    return new re();
  } : t, r = e.resetOnError, i = r === void 0 ? !0 : r, o = e.resetOnComplete, s = o === void 0 ? !0 : o, a = e.resetOnRefCountZero, c = a === void 0 ? !0 : a;
  return function(u) {
    var l, f, h, d = 0, m = !1, p = !1, g = function() {
      f?.unsubscribe(), f = void 0;
    }, v = function() {
      g(), l = h = void 0, m = p = !1;
    }, x = function() {
      var C = l;
      v(), C?.unsubscribe();
    };
    return B(function(C, T) {
      d++, !p && !m && g();
      var S = h = h ?? n();
      T.add(function() {
        d--, d === 0 && !p && !m && (f = at(x, c));
      }), S.subscribe(T), !l && d > 0 && (l = new Ae({
        next: function(b) {
          return S.next(b);
        },
        error: function(b) {
          p = !0, g(), f = at(v, i, b), S.error(b);
        },
        complete: function() {
          m = !0, g(), f = at(v, s), S.complete();
        }
      }), Q(C).subscribe(l));
    })(u);
  };
}
function at(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  if (t === !0) {
    e();
    return;
  }
  if (t !== !1) {
    var i = new Ae({
      next: function() {
        i.unsubscribe(), e();
      }
    });
    return Q(t.apply(void 0, Se([], ve(n)))).subscribe(i);
  }
}
function Ki(e) {
  return B(function(t, n) {
    var r = !1, i = z(n, function() {
      i?.unsubscribe(), r = !0;
    }, ze);
    Q(e).subscribe(i), t.subscribe(z(n, function(o) {
      return r && n.next(o);
    }));
  });
}
function U() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = Et(e);
  return B(function(r, i) {
    (n ? Ye(e, r, n) : Ye(e, r)).subscribe(i);
  });
}
function _n(e, t) {
  return B(function(n, r) {
    var i = null, o = 0, s = !1, a = function() {
      return s && !i && r.complete();
    };
    n.subscribe(z(r, function(c) {
      i?.unsubscribe();
      var u = 0, l = o++;
      Q(e(c, l)).subscribe(i = z(r, function(f) {
        return r.next(t ? t(c, f, l, u++) : f);
      }, function() {
        i = null, a();
      }));
    }, function() {
      s = !0, a();
    }));
  });
}
function Vt(e) {
  return B(function(t, n) {
    Q(e).subscribe(z(n, function() {
      return n.complete();
    }, ze)), !n.closed && t.subscribe(n);
  });
}
function qi(e, t, n) {
  var r = A(e) || t || n ? { next: e, error: t, complete: n } : e;
  return r ? B(function(i, o) {
    var s;
    (s = r.subscribe) === null || s === void 0 || s.call(r);
    var a = !0;
    i.subscribe(z(o, function(c) {
      var u;
      (u = r.next) === null || u === void 0 || u.call(r, c), o.next(c);
    }, function() {
      var c;
      a = !1, (c = r.complete) === null || c === void 0 || c.call(r), o.complete();
    }, function(c) {
      var u;
      a = !1, (u = r.error) === null || u === void 0 || u.call(r, c), o.error(c);
    }, function() {
      var c, u;
      a && ((c = r.unsubscribe) === null || c === void 0 || c.call(r)), (u = r.finalize) === null || u === void 0 || u.call(r);
    }));
  }) : tt;
}
var Gi = Object.defineProperty, Qi = Object.defineProperties, Xi = Object.getOwnPropertyDescriptors, Ht = Object.getOwnPropertySymbols, Ji = Object.prototype.hasOwnProperty, Zi = Object.prototype.propertyIsEnumerable, zt = (e, t) => (t = Symbol[e]) ? t : /* @__PURE__ */ Symbol.for("Symbol." + e), Yt = (e, t, n) => t in e ? Gi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, J = (e, t) => {
  for (var n in t || (t = {}))
    Ji.call(t, n) && Yt(e, n, t[n]);
  if (Ht)
    for (var n of Ht(t))
      Zi.call(t, n) && Yt(e, n, t[n]);
  return e;
}, fe = (e, t) => Qi(e, Xi(t)), H = (e, t, n) => new Promise((r, i) => {
  var o = (c) => {
    try {
      a(n.next(c));
    } catch (u) {
      i(u);
    }
  }, s = (c) => {
    try {
      a(n.throw(c));
    } catch (u) {
      i(u);
    }
  }, a = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(o, s);
  a((n = n.apply(e, t)).next());
}), eo = (e, t, n) => (t = e[zt("asyncIterator")]) ? t.call(e) : (e = e[zt("iterator")](), t = {}, n = (r, i) => (i = e[r]) && (t[r] = (o) => new Promise((s, a, c) => (o = i.call(e, o), c = o.done, Promise.resolve(o.value).then((u) => s({ value: u, done: c }), a)))), n("next"), n("return"), t), kn = "lk";
function q(e) {
  return typeof e > "u" ? !1 : to(e) || no(e);
}
function to(e) {
  var t;
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && e.hasOwnProperty("track") && typeof ((t = e.publication) == null ? void 0 : t.track) < "u" : !1;
}
function no(e) {
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && e.hasOwnProperty("publication") && typeof e.publication < "u" : !1;
}
function ke(e) {
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && typeof e.publication > "u" : !1;
}
function V(e) {
  if (typeof e == "string" || typeof e == "number")
    return `${e}`;
  if (ke(e))
    return `${e.participant.identity}_${e.source}_placeholder`;
  if (q(e))
    return `${e.participant.identity}_${e.publication.source}_${e.publication.trackSid}`;
  throw new Error(`Can't generate a id for the given track reference: ${e}`);
}
function ts(e, t) {
  return e === void 0 || t === void 0 ? !1 : q(e) && q(t) ? e.publication.trackSid === t.publication.trackSid : V(e) === V(t);
}
function ns(e, t) {
  return typeof t > "u" ? !1 : q(e) ? t.some(
    (n) => n.participant.identity === e.participant.identity && q(n) && n.publication.trackSid === e.publication.trackSid
  ) : ke(e) ? t.some(
    (n) => n.participant.identity === e.participant.identity && ke(n) && n.source === e.source
  ) : !1;
}
function ro(e, t) {
  return ke(e) && q(t) && t.participant.identity === e.participant.identity && t.source === e.source;
}
function rs() {
  const e = document.createElement("p");
  e.style.width = "100%", e.style.height = "200px";
  const t = document.createElement("div");
  t.style.position = "absolute", t.style.top = "0px", t.style.left = "0px", t.style.visibility = "hidden", t.style.width = "200px", t.style.height = "150px", t.style.overflow = "hidden", t.appendChild(e), document.body.appendChild(t);
  const n = e.offsetWidth;
  t.style.overflow = "scroll";
  let r = e.offsetWidth;
  return n === r && (r = t.clientWidth), document.body.removeChild(t), n - r;
}
function is() {
  return typeof document < "u";
}
function io(e) {
  e = J({}, e);
  const t = "(?:(?:[a-z]+:)?//)?", n = "(?:\\S+(?::\\S*)?@)?", r = new RegExp(
    "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}",
    "g"
  ).source, u = `(?:${t}|www\\.)${n}(?:localhost|${r}|(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#][^\\s"]*)?`;
  return e.exact ? new RegExp(`(?:^${u}$)`, "i") : new RegExp(u, "ig");
}
var Kt = "[^\\.\\s@:](?:[^\\s@:]*[^\\s@:\\.])?@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)*";
function oo({ exact: e } = {}) {
  return e ? new RegExp(`^${Kt}$`) : new RegExp(Kt, "g");
}
function os(e, t, n) {
  return $r(e, t, () => H(null, null, function* () {
    const { x: i, y: o } = yield Wr(e, t, {
      placement: "top",
      middleware: [Nr(6), Ur(), Fr({ padding: 5 })]
    });
    n?.(i, o);
  }));
}
function ss(e, t) {
  return !e.contains(t.target);
}
var as = () => ({
  email: oo(),
  url: io({})
});
function cs(e, t) {
  const n = Object.entries(t).map(
    ([o, s], a) => Array.from(e.matchAll(s)).map(({ index: c, 0: u }) => ({
      type: o,
      weight: a,
      content: u,
      index: c ?? 0
    }))
  ).flat().sort((o, s) => {
    const a = o.index - s.index;
    return a !== 0 ? a : o.weight - s.weight;
  }).filter(({ index: o }, s, a) => {
    if (s === 0) return !0;
    const c = a[s - 1];
    return c.index + c.content.length <= o;
  }), r = [];
  let i = 0;
  for (const { type: o, content: s, index: a } of n)
    a > i && r.push(e.substring(i, a)), r.push({ type: o, content: s }), i = a + s.length;
  return e.length > i && r.push(e.substring(i)), r;
}
var so = [
  y.ConnectionStateChanged,
  y.RoomMetadataChanged,
  y.ActiveSpeakersChanged,
  y.ConnectionQualityChanged,
  y.ParticipantConnected,
  y.ParticipantDisconnected,
  y.ParticipantPermissionsChanged,
  y.ParticipantMetadataChanged,
  y.ParticipantNameChanged,
  y.ParticipantAttributesChanged,
  y.TrackMuted,
  y.TrackUnmuted,
  y.TrackPublished,
  y.TrackUnpublished,
  y.TrackStreamStateChanged,
  y.TrackSubscriptionFailed,
  y.TrackSubscriptionPermissionChanged,
  y.TrackSubscriptionStatusChanged
], Ln = [
  ...so,
  y.LocalTrackPublished,
  y.LocalTrackUnpublished
], ao = [
  w.TrackPublished,
  w.TrackUnpublished,
  w.TrackMuted,
  w.TrackUnmuted,
  w.TrackStreamStateChanged,
  w.TrackSubscribed,
  w.TrackUnsubscribed,
  w.TrackSubscriptionPermissionChanged,
  w.TrackSubscriptionFailed,
  w.LocalTrackPublished,
  w.LocalTrackUnpublished
], co = [
  w.ConnectionQualityChanged,
  w.IsSpeakingChanged,
  w.ParticipantMetadataChanged,
  w.ParticipantPermissionsChanged,
  w.TrackMuted,
  w.TrackUnmuted,
  w.TrackPublished,
  w.TrackUnpublished,
  w.TrackStreamStateChanged,
  w.TrackSubscriptionFailed,
  w.TrackSubscriptionPermissionChanged,
  w.TrackSubscriptionStatusChanged
], In = [
  ...co,
  w.LocalTrackPublished,
  w.LocalTrackUnpublished
], I = zr.getLogger("lk-components-js");
I.setDefaultLevel("WARN");
function us(e, t = {}) {
  var n;
  I.setLevel(e), Xn((n = t.liveKitClientLogLevel) != null ? n : e);
}
function ls(e, t = {}) {
  var n;
  const r = I.methodFactory;
  I.methodFactory = (i, o, s) => {
    const a = r(i, o, s), c = Pt[i], u = c >= o && c < Pt.silent;
    return (l, f) => {
      f ? a(l, f) : a(l), u && e(c, l, f);
    };
  }, I.setLevel(I.getLevel()), Qn((n = t.liveKitClientLogExtension) != null ? n : e);
}
var fs = [
  {
    columns: 1,
    rows: 1
  },
  {
    columns: 1,
    rows: 2,
    orientation: "portrait"
  },
  {
    columns: 2,
    rows: 1,
    orientation: "landscape"
  },
  {
    columns: 2,
    rows: 2,
    minWidth: 560
  },
  {
    columns: 3,
    rows: 3,
    minWidth: 700
  },
  {
    columns: 4,
    rows: 4,
    minWidth: 960
  },
  {
    columns: 5,
    rows: 5,
    minWidth: 1100
  }
];
function uo(e, t, n, r) {
  if (e.length < 1)
    throw new Error("At least one grid layout definition must be provided.");
  const i = lo(e);
  if (n <= 0 || r <= 0)
    return i[0];
  let o = 0;
  const s = n / r > 1 ? "landscape" : "portrait";
  let a = i.find((c, u, l) => {
    o = u;
    const f = l.findIndex((h, d) => {
      const m = !h.orientation || h.orientation === s, p = d > u, g = h.maxTiles === c.maxTiles;
      return p && g && m;
    }) !== -1;
    return c.maxTiles >= t && !f;
  });
  if (a === void 0)
    if (a = i[i.length - 1], a)
      I.warn(
        `No layout found for: participantCount: ${t}, width/height: ${n}/${r} fallback to biggest available layout (${a}).`
      );
    else
      throw new Error("No layout or fallback layout found.");
  if ((n < a.minWidth || r < a.minHeight) && o > 0) {
    const c = i[o - 1];
    a = uo(
      i.slice(0, o),
      c.maxTiles,
      n,
      r
    );
  }
  return a;
}
function lo(e) {
  return [...e].map((t) => {
    var n, r;
    return {
      name: `${t.columns}x${t.rows}`,
      columns: t.columns,
      rows: t.rows,
      maxTiles: t.columns * t.rows,
      minWidth: (n = t.minWidth) != null ? n : 0,
      minHeight: (r = t.minHeight) != null ? r : 0,
      orientation: t.orientation
    };
  }).sort((t, n) => t.maxTiles !== n.maxTiles ? t.maxTiles - n.maxTiles : t.minWidth !== 0 || n.minWidth !== 0 ? t.minWidth - n.minWidth : t.minHeight !== 0 || n.minHeight !== 0 ? t.minHeight - n.minHeight : 0);
}
function ds() {
  return typeof navigator < "u" && navigator.mediaDevices && !!navigator.mediaDevices.getDisplayMedia;
}
function ps(e, t) {
  var n;
  return fe(J({}, e), {
    receivedAtMediaTimestamp: (n = t.rtpTimestamp) != null ? n : 0,
    receivedAt: t.timestamp
  });
}
function hs(e, t, n) {
  return [...e, ...t].reduceRight((r, i) => (r.find((o) => o.id === i.id) || r.unshift(i), r), []).slice(0 - n);
}
var fo = /* @__PURE__ */ ((e) => (e.AgentState = "lk.agent.state", e.PublishOnBehalf = "lk.publish_on_behalf", e.TranscriptionFinal = "lk.transcription_final", e.TranscriptionSegmentId = "lk.segment_id", e.TranscribedTrackId = "lk.transcribed_track_id", e))(fo || {}), Rn = [], Mn = {
  showChat: !1,
  unreadMessages: 0,
  showSettings: !1
};
function po(e) {
  return typeof e == "object";
}
function vs(e) {
  return Array.isArray(e) && e.filter(po).length > 0;
}
function Dn(e, t) {
  return t.audioLevel - e.audioLevel;
}
function $n(e, t) {
  return e.isSpeaking === t.isSpeaking ? 0 : e.isSpeaking ? -1 : 1;
}
function Nn(e, t) {
  var n, r, i, o;
  return e.lastSpokeAt !== void 0 || t.lastSpokeAt !== void 0 ? ((r = (n = t.lastSpokeAt) == null ? void 0 : n.getTime()) != null ? r : 0) - ((o = (i = e.lastSpokeAt) == null ? void 0 : i.getTime()) != null ? o : 0) : 0;
}
function Ke(e, t) {
  var n, r, i, o;
  return ((r = (n = e.joinedAt) == null ? void 0 : n.getTime()) != null ? r : 0) - ((o = (i = t.joinedAt) == null ? void 0 : i.getTime()) != null ? o : 0);
}
function ho(e, t) {
  return q(e) ? q(t) ? 0 : -1 : q(t) ? 1 : 0;
}
function vo(e, t) {
  const n = e.participant.isCameraEnabled, r = t.participant.isCameraEnabled;
  return n !== r ? n ? -1 : 1 : 0;
}
function ms(e) {
  const t = [], n = [], r = [], i = [];
  e.forEach((a) => {
    a.participant.isLocal && a.source === F.Source.Camera ? t.push(a) : a.source === F.Source.ScreenShare ? n.push(a) : a.source === F.Source.Camera ? r.push(a) : i.push(a);
  });
  const o = mo(n), s = go(r);
  return [...t, ...o, ...s, ...i];
}
function mo(e) {
  const t = [], n = [];
  return e.forEach((i) => {
    i.participant.isLocal ? t.push(i) : n.push(i);
  }), t.sort((i, o) => Ke(i.participant, o.participant)), n.sort((i, o) => Ke(i.participant, o.participant)), [...n, ...t];
}
function go(e) {
  const t = [], n = [];
  return e.forEach((r) => {
    r.participant.isLocal ? t.push(r) : n.push(r);
  }), n.sort((r, i) => r.participant.isSpeaking && i.participant.isSpeaking ? Dn(r.participant, i.participant) : r.participant.isSpeaking !== i.participant.isSpeaking ? $n(r.participant, i.participant) : r.participant.lastSpokeAt !== i.participant.lastSpokeAt ? Nn(r.participant, i.participant) : q(r) !== q(i) ? ho(r, i) : r.participant.isCameraEnabled !== i.participant.isCameraEnabled ? vo(r, i) : Ke(r.participant, i.participant)), [...t, ...n];
}
function gs(e) {
  const t = [...e];
  t.sort((r, i) => {
    if (r.isSpeaking && i.isSpeaking)
      return Dn(r, i);
    if (r.isSpeaking !== i.isSpeaking)
      return $n(r, i);
    if (r.lastSpokeAt !== i.lastSpokeAt)
      return Nn(r, i);
    const o = r.videoTrackPublications.size > 0, s = i.videoTrackPublications.size > 0;
    return o !== s ? o ? -1 : 1 : Ke(r, i);
  });
  const n = t.find((r) => r.isLocal);
  if (n) {
    const r = t.indexOf(n);
    r >= 0 && (t.splice(r, 1), t.length > 0 ? t.splice(0, 0, n) : t.push(n));
  }
  return t;
}
function bo(e, t) {
  return e.reduce(
    (n, r, i) => i % t === 0 ? [...n, [r]] : [...n.slice(0, -1), [...n.slice(-1)[0], r]],
    []
  );
}
function qt(e, t) {
  const n = Math.max(e.length, t.length);
  return new Array(n).fill([]).map((r, i) => [e[i], t[i]]);
}
function qe(e, t, n) {
  return e.filter((r) => !t.map((i) => n(i)).includes(n(r)));
}
function mt(e) {
  return e.map((t) => typeof t == "string" || typeof t == "number" ? `${t}` : V(t));
}
function yo(e, t) {
  return {
    dropped: qe(e, t, V),
    added: qe(t, e, V)
  };
}
function wo(e) {
  return e.added.length !== 0 || e.dropped.length !== 0;
}
function gt(e, t) {
  const n = t.findIndex(
    (r) => V(r) === V(e)
  );
  if (n === -1)
    throw new Error(
      `Element not part of the array: ${V(
        e
      )} not in ${mt(t)}`
    );
  return n;
}
function xo(e, t, n) {
  const r = gt(e, n), i = gt(t, n);
  return n.splice(r, 1, t), n.splice(i, 1, e), n;
}
function So(e, t) {
  const n = gt(e, t);
  return t.splice(n, 1), t;
}
function Co(e, t) {
  return [...t, e];
}
function ct(e, t) {
  return bo(e, t);
}
function bs(e, t, n) {
  let r = Eo(e, t);
  if (r.length < t.length) {
    const s = qe(t, r, V);
    r = [...r, ...s];
  }
  const i = ct(r, n), o = ct(t, n);
  if (qt(i, o).forEach(([s, a], c) => {
    if (s && a) {
      const u = ct(r, n)[c], l = yo(u, a);
      wo(l) && (I.debug(
        `Detected visual changes on page: ${c}, current: ${mt(
          s
        )}, next: ${mt(a)}`,
        { changes: l }
      ), l.added.length === l.dropped.length && qt(l.added, l.dropped).forEach(([f, h]) => {
        if (f && h)
          r = xo(f, h, r);
        else
          throw new Error(
            `For a swap action we need a addition and a removal one is missing: ${f}, ${h}`
          );
      }), l.added.length === 0 && l.dropped.length > 0 && l.dropped.forEach((f) => {
        r = So(f, r);
      }), l.added.length > 0 && l.dropped.length === 0 && l.added.forEach((f) => {
        r = Co(f, r);
      }));
    }
  }), r.length > t.length) {
    const s = qe(r, t, V);
    r = r.filter(
      (a) => !s.map(V).includes(V(a))
    );
  }
  return r;
}
function Eo(e, t) {
  return e.map((n) => {
    const r = t.find(
      (i) => (
        // If the IDs match or ..
        V(n) === V(i) || // ... if the current item is a placeholder and the new item is the track reference can replace it.
        typeof n != "number" && ke(n) && q(i) && ro(n, i)
      )
    );
    return r ?? n;
  });
}
function Y(e) {
  return `${kn}-${e}`;
}
function ys(e) {
  const t = Gt(e), n = Fn(e.participant).pipe(
    _(() => Gt(e)),
    U(t)
  );
  return { className: Y(
    e.source === F.Source.Camera || e.source === F.Source.ScreenShare ? "participant-media-video" : "participant-media-audio"
  ), trackObserver: n };
}
function Gt(e) {
  if (q(e))
    return e.publication;
  {
    const { source: t, name: n, participant: r } = e;
    if (t && n)
      return r.getTrackPublications().find((i) => i.source === t && i.trackName === n);
    if (n)
      return r.getTrackPublicationByName(n);
    if (t)
      return r.getTrackPublication(t);
    throw new Error("At least one of source and name needs to be defined");
  }
}
function me(e, ...t) {
  return new L((r) => {
    const i = () => {
      r.next(e);
    };
    return t.forEach((s) => {
      e.on(s, i);
    }), () => {
      t.forEach((s) => {
        e.off(s, i);
      });
    };
  }).pipe(U(e));
}
function Ee(e, t) {
  return new L((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function ws(e) {
  return Ee(e, y.ConnectionStateChanged).pipe(
    _(([t]) => t),
    U(e.state)
  );
}
function xs(e) {
  return me(
    e,
    y.RoomMetadataChanged,
    y.ConnectionStateChanged
  ).pipe(
    _((n) => ({ name: n.name, metadata: n.metadata }))
  );
}
function Ss(e) {
  return Ee(e, y.ActiveSpeakersChanged).pipe(
    _(([t]) => t)
  );
}
function Cs(e, t, n = !0) {
  const r = new L((o) => {
    Ot.getLocalDevices(e, n).then((s) => {
      o.next(s), o.complete();
    }).catch((s) => {
      t?.(s), o.next([]), o.complete();
    });
  }), i = new L((o) => {
    var s;
    const a = () => H(null, null, function* () {
      try {
        const c = yield Ot.getLocalDevices(e, n);
        o.next(c);
      } catch (c) {
        t?.(c);
      }
    });
    if (typeof window < "u") {
      if (!window.isSecureContext)
        throw new Error(
          "Accessing media devices is available only in secure contexts (HTTPS and localhost), in some or all supporting browsers. See: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/mediaDevices"
        );
      (s = navigator?.mediaDevices) == null || s.addEventListener("devicechange", a);
    }
    return () => {
      var c;
      (c = navigator?.mediaDevices) == null || c.removeEventListener("devicechange", a);
    };
  });
  return Ye(r, i);
}
function To(e) {
  return Ee(e, y.DataReceived);
}
function Po(e) {
  return me(e, y.AudioPlaybackStatusChanged).pipe(
    _((n) => ({ canPlayAudio: n.canPlaybackAudio }))
  );
}
function Oo(e) {
  return me(e, y.VideoPlaybackStatusChanged).pipe(
    _((n) => ({ canPlayVideo: n.canPlaybackVideo }))
  );
}
function Ao(e, t) {
  return Ee(e, y.ActiveDeviceChanged).pipe(
    nt(([n]) => n === t),
    _(([n, r]) => (I.debug("activeDeviceObservable | RoomEvent.ActiveDeviceChanged", { kind: n, deviceId: r }), r))
  );
}
function Es(e, t) {
  return Ee(e, y.ParticipantEncryptionStatusChanged).pipe(
    nt(
      ([, n]) => t?.identity === n?.identity || !n && t?.identity === e.localParticipant.identity
    ),
    _(([n]) => n),
    U(
      t?.isLocal ? t.isE2EEEnabled : !!t?.isEncrypted
    )
  );
}
function Ts(e) {
  return Ee(e, y.RecordingStatusChanged).pipe(
    _(([t]) => t),
    U(e.isRecording)
  );
}
function Te(e, ...t) {
  return new L((r) => {
    const i = () => {
      r.next(e);
    };
    return t.forEach((s) => {
      e.on(s, i);
    }), () => {
      t.forEach((s) => {
        e.off(s, i);
      });
    };
  }).pipe(U(e));
}
function Fn(e) {
  return Te(
    e,
    w.TrackMuted,
    w.TrackUnmuted,
    w.ParticipantPermissionsChanged,
    // ParticipantEvent.IsSpeakingChanged,
    w.TrackPublished,
    w.TrackUnpublished,
    w.LocalTrackPublished,
    w.LocalTrackUnpublished,
    w.MediaDevicesError,
    w.TrackSubscriptionStatusChanged
    // ParticipantEvent.ConnectionQualityChanged,
  ).pipe(
    _((n) => {
      const { isMicrophoneEnabled: r, isCameraEnabled: i, isScreenShareEnabled: o } = n, s = n.getTrackPublication(F.Source.Microphone), a = n.getTrackPublication(F.Source.Camera);
      return {
        isCameraEnabled: i,
        isMicrophoneEnabled: r,
        isScreenShareEnabled: o,
        cameraTrack: a,
        microphoneTrack: s,
        participant: n
      };
    })
  );
}
function _o(e) {
  return e ? Te(
    e,
    w.ParticipantMetadataChanged,
    w.ParticipantNameChanged
  ).pipe(
    _(({ name: n, identity: r, metadata: i }) => ({
      name: n,
      identity: r,
      metadata: i
    })),
    U({
      name: e.name,
      identity: e.identity,
      metadata: e.metadata
    })
  ) : void 0;
}
function ko(e) {
  return rt(
    e,
    w.ConnectionQualityChanged
  ).pipe(
    _(([n]) => n),
    U(e.connectionQuality)
  );
}
function rt(e, t) {
  return new L((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function Lo(e) {
  var t, n, r, i;
  return Te(
    e.participant,
    w.TrackMuted,
    w.TrackUnmuted,
    w.TrackSubscribed,
    w.TrackUnsubscribed,
    w.LocalTrackPublished,
    w.LocalTrackUnpublished
  ).pipe(
    _((o) => {
      var s, a;
      const c = (s = e.publication) != null ? s : o.getTrackPublication(e.source);
      return (a = c?.isMuted) != null ? a : !0;
    }),
    U(
      (i = (r = (t = e.publication) == null ? void 0 : t.isMuted) != null ? r : (n = e.participant.getTrackPublication(e.source)) == null ? void 0 : n.isMuted) != null ? i : !0
    )
  );
}
function Ps(e) {
  return rt(e, w.IsSpeakingChanged).pipe(
    _(([t]) => t)
  );
}
function Os(e, t = {}) {
  var n;
  let r;
  const i = new L((c) => (r = c, () => a.unsubscribe())).pipe(U(Array.from(e.remoteParticipants.values()))), o = (n = t.additionalRoomEvents) != null ? n : Ln, s = Array.from(
    /* @__PURE__ */ new Set([
      y.ParticipantConnected,
      y.ParticipantDisconnected,
      y.ConnectionStateChanged,
      ...o
    ])
  ), a = me(e, ...s).subscribe(
    (c) => r?.next(Array.from(c.remoteParticipants.values()))
  );
  return e.remoteParticipants.size > 0 && r?.next(Array.from(e.remoteParticipants.values())), i;
}
function As(e, t, n = {}) {
  var r;
  const i = (r = n.additionalEvents) != null ? r : In;
  return me(
    e,
    y.ParticipantConnected,
    y.ParticipantDisconnected,
    y.ConnectionStateChanged
  ).pipe(
    _n((s) => {
      const a = s.getParticipantByIdentity(t);
      return a ? Te(a, ...i) : new L((c) => c.next(void 0));
    }),
    U(e.getParticipantByIdentity(t))
  );
}
function _s(e) {
  return rt(
    e,
    w.ParticipantPermissionsChanged
  ).pipe(
    _(() => e.permissions),
    U(e.permissions)
  );
}
function ks(e, { kind: t, identity: n }, r = {}) {
  var i;
  const o = (i = r.additionalEvents) != null ? i : In, s = (c) => {
    let u = !0;
    return t && (u = u && c.kind === t), n && (u = u && c.identity === n), u;
  };
  return me(
    e,
    y.ParticipantConnected,
    y.ParticipantDisconnected,
    y.ConnectionStateChanged
  ).pipe(
    _n((c) => {
      const u = Array.from(c.remoteParticipants.values()).find(
        (l) => s(l)
      );
      return u ? Te(u, ...o) : new L((l) => l.next(void 0));
    }),
    U(Array.from(e.remoteParticipants.values()).find((c) => s(c)))
  );
}
function Ls(e) {
  return typeof e > "u" ? new L() : rt(e, w.AttributesChanged).pipe(
    _(([t]) => ({
      changed: t,
      attributes: e.attributes
    })),
    U({ changed: e.attributes, attributes: e.attributes })
  );
}
function Is(e, t, n, r, i) {
  const { localParticipant: o } = t, s = (f, h) => {
    let d = !1;
    switch (f) {
      case F.Source.Camera:
        d = h.isCameraEnabled;
        break;
      case F.Source.Microphone:
        d = h.isMicrophoneEnabled;
        break;
      case F.Source.ScreenShare:
        d = h.isScreenShareEnabled;
        break;
    }
    return d;
  }, a = Fn(o).pipe(
    _((f) => s(e, f.participant)),
    U(s(e, o))
  ), c = new re(), u = (f, h) => H(null, null, function* () {
    try {
      switch (h ?? (h = n), c.next(!0), e) {
        case F.Source.Camera:
          return yield o.setCameraEnabled(
            f ?? !o.isCameraEnabled,
            h,
            r
          ), o.isCameraEnabled;
        case F.Source.Microphone:
          return yield o.setMicrophoneEnabled(
            f ?? !o.isMicrophoneEnabled,
            h,
            r
          ), o.isMicrophoneEnabled;
        case F.Source.ScreenShare:
          return yield o.setScreenShareEnabled(
            f ?? !o.isScreenShareEnabled,
            h,
            r
          ), o.isScreenShareEnabled;
        default:
          throw new TypeError("Tried to toggle unsupported source");
      }
    } catch (d) {
      if (i && d instanceof Error) {
        i?.(d);
        return;
      } else
        throw d;
    } finally {
      c.next(!1);
    }
  });
  return {
    className: Y("button"),
    toggle: u,
    enabledObserver: a,
    pendingObserver: c.asObservable()
  };
}
function Rs() {
  let e = !1;
  const t = new re(), n = new re(), r = (o) => H(null, null, function* () {
    n.next(!0), e = o ?? !e, t.next(e), n.next(!1);
  });
  return {
    className: Y("button"),
    toggle: r,
    enabledObserver: t.asObservable(),
    pendingObserver: n.asObservable()
  };
}
function Ms(e, t, n) {
  const r = new mn(void 0), i = Ao(t, e), o = (a, ...c) => H(null, [a, ...c], function* (u, l = {}) {
    var f, h, d;
    if (n) {
      yield n.setDeviceId(l.exact ? { exact: u } : u);
      const m = yield n.getDeviceId(!1);
      r.next(
        u === "default" && n.mediaStreamTrack.label.startsWith("Default") ? u : m
      );
    } else if (t) {
      const m = Jn();
      if (e === "audiooutput" && (m?.name === "Safari" || m?.os === "iOS")) {
        I.warn("Switching audio output device is not supported on Safari and iOS.");
        return;
      }
      I.debug(`Switching active device of kind "${e}" with id ${u}.`), yield t.switchActiveDevice(e, u, l.exact);
      const p = (f = t.getActiveDevice(e)) != null ? f : u;
      p !== u && u !== "default" && I.info(
        `We tried to select the device with id (${u}), but the browser decided to select the device with id (${p}) instead.`
      );
      let g;
      e === "audioinput" ? g = (h = t.localParticipant.getTrackPublication(F.Source.Microphone)) == null ? void 0 : h.track : e === "videoinput" && (g = (d = t.localParticipant.getTrackPublication(F.Source.Camera)) == null ? void 0 : d.track);
      const v = u === "default" && !g || u === "default" && g?.mediaStreamTrack.label.startsWith("Default");
      r.next(v ? u : p);
    }
  });
  return {
    className: Y("media-device-select"),
    activeDeviceObservable: i,
    setActiveMediaDevice: o
  };
}
function Ds(e) {
  const t = (r) => {
    e.disconnect(r);
  };
  return { className: Y("disconnect-button"), disconnect: t };
}
function $s(e) {
  const t = Y("connection-quality"), n = ko(e);
  return { className: t, connectionQualityObserver: n };
}
function Ns(e) {
  let t = "track-muted-indicator-camera";
  switch (e.source) {
    case F.Source.Camera:
      t = "track-muted-indicator-camera";
      break;
    case F.Source.Microphone:
      t = "track-muted-indicator-microphone";
      break;
  }
  const n = Y(t), r = Lo(e);
  return { className: n, mediaMutedObserver: r };
}
function Fs(e) {
  return { className: "lk-participant-name", infoObserver: _o(e) };
}
function Us() {
  return {
    className: Y("participant-tile")
  };
}
var Io = {
  CHAT: "lk.chat",
  TRANSCRIPTION: "lk.transcription"
}, Ro = {
  CHAT: "lk-chat-topic"
};
function Un(e, t) {
  return H(this, arguments, function* (n, r, i = {}) {
    const { reliable: o, destinationIdentities: s, topic: a } = i;
    yield n.publishData(r, {
      destinationIdentities: s,
      topic: a,
      reliable: o
    });
  });
}
function Mo(e, t, n) {
  const r = Array.isArray(t) ? t : [t], i = To(e).pipe(
    nt(
      ([, , , c]) => t === void 0 || c !== void 0 && r.includes(c)
    ),
    _(([c, u, , l]) => {
      const f = {
        payload: c,
        topic: l,
        from: u
      };
      return n?.(f), f;
    })
  );
  let o;
  const s = new L((c) => {
    o = c;
  });
  return { messageObservable: i, isSendingObservable: s, send: (c, ...u) => H(null, [c, ...u], function* (l, f = {}) {
    o.next(!0);
    try {
      yield Un(e.localParticipant, l, J({ topic: r[0] }, f));
    } finally {
      o.next(!1);
    }
  }) };
}
var Do = class {
  constructor(e, t) {
    this._isResolved = !1, this.onFinally = t, this.promise = new Promise((n, r) => H(this, null, function* () {
      this.resolve = n, this.reject = r, e && (yield e(n, r));
    })).finally(() => {
      var n;
      this._isResolved = !0, (n = this.onFinally) == null || n.call(this);
    });
  }
  get isResolved() {
    return this._isResolved;
  }
}, De = /* @__PURE__ */ new WeakMap(), $e = /* @__PURE__ */ new Map();
function $o(e) {
  return e.ignoreLegacy == !0;
}
var No = (e) => JSON.parse(new TextDecoder().decode(e)), Fo = (e) => new TextEncoder().encode(JSON.stringify(e));
function Ws(e, t) {
  var n, r, i, o, s, a;
  const c = () => {
    var S, b, P;
    return ((S = e.serverInfo) == null ? void 0 : S.edition) === 1 || !!((b = e.serverInfo) != null && b.version) && Zn((P = e.serverInfo) == null ? void 0 : P.version, "1.8.2") > 0;
  }, u = new re(), l = (n = t?.channelTopic) != null ? n : Io.CHAT, f = (r = t?.channelTopic) != null ? r : Ro.CHAT;
  let h = !1;
  De.has(e) || (h = !0);
  const d = (i = De.get(e)) != null ? i : /* @__PURE__ */ new Map(), m = (o = d.get(l)) != null ? o : new re();
  d.set(l, m), De.set(e, d);
  const p = (s = t?.messageDecoder) != null ? s : No;
  if (h) {
    e.registerTextStreamHandler(l, (b, P) => H(null, null, function* () {
      const { id: R, timestamp: M, attributes: W, attachedStreamIds: E } = b.info, O = new Map(
        (E ?? []).map((k) => [
          k,
          new Do()
        ])
      );
      $e.set(R, O), ye(b).pipe(
        Ue((k, $) => k + $),
        _e((k) => O.size === 0 ? ht({ chunk: k, attachedFiles: [] }) : ye(O.values()).pipe(
          _e(($) => ye($.promise)),
          Ue(
            ($, G) => [...$, new File(G.buffer, G.fileName)],
            []
          ),
          _(($) => ({ chunk: k, attachedFiles: $ }))
        )),
        _(({ chunk: k, attachedFiles: $ }) => ({
          id: R,
          timestamp: M,
          message: k,
          from: e.getParticipantByIdentity(P.identity),
          type: "chatMessage",
          attributes: W,
          attachedFiles: $
          // editTimestamp: type === 'update' ? timestamp : undefined,
        })),
        zi(() => $e.delete(R))
      ).subscribe({
        next: (k) => m.next(k)
      });
    })), e.registerByteStreamHandler(l, (b) => H(null, null, function* () {
      var P, R;
      const { id: M } = b.info, W = Array.from($e).find(
        ([, N]) => N.has(M)
      );
      if (!W)
        return;
      const E = W[0], O = [];
      try {
        for (var j = eo(b), k, $, G; k = !($ = yield j.next()).done; k = !1) {
          const N = $.value;
          O.push(N);
        }
      } catch (N) {
        G = [N];
      } finally {
        try {
          k && ($ = j.return) && (yield $.call(j));
        } finally {
          if (G)
            throw G[0];
        }
      }
      const X = (P = $e.get(E)) == null ? void 0 : P.get(M);
      X && ((R = X.resolve) == null || R.call(X, {
        fileName: b.info.name,
        buffer: O
      }));
    }));
    const { messageObservable: S } = Mo(e, [f]);
    S.pipe(
      _((b) => {
        const P = p(b.payload);
        return $o(P) ? void 0 : fe(J({}, P), {
          type: "chatMessage",
          from: b.from
        });
      }),
      nt((b) => !!b),
      Vt(u)
    ).subscribe(m);
  }
  const g = m.pipe(
    Ue((S, b) => {
      if ("id" in b && S.find((P) => {
        var R, M;
        return ((R = P.from) == null ? void 0 : R.identity) === ((M = b.from) == null ? void 0 : M.identity) && P.id === b.id;
      })) {
        const P = S.findIndex((R) => R.id === b.id);
        if (P > -1) {
          const R = S[P];
          S[P] = fe(J({}, b), {
            timestamp: R.timestamp,
            editTimestamp: b.timestamp
          });
        }
        return [...S];
      }
      return [...S, b];
    }, []),
    Vt(u)
  ), v = new mn(!1), x = (a = t?.messageEncoder) != null ? a : Fo, C = (S, b) => H(null, null, function* () {
    var P;
    b || (b = {}), (P = b.topic) != null || (b.topic = l), v.next(!0);
    try {
      const M = {
        id: (yield e.localParticipant.sendText(S, b)).id,
        timestamp: Date.now(),
        message: S
      }, W = fe(J({}, M), {
        attachedFiles: b.attachments
      }), E = fe(J({}, W), {
        type: "chatMessage",
        from: e.localParticipant,
        attributes: b.attributes
      });
      m.next(E);
      const O = x(fe(J({}, M), {
        ignoreLegacy: c()
      }));
      try {
        yield Un(e.localParticipant, O, {
          reliable: !0,
          topic: f
        });
      } catch (j) {
        I.info("could not send message in legacy chat format", j);
      }
      return E;
    } finally {
      v.next(!1);
    }
  });
  function T() {
    u.next(), u.complete(), m.complete(), De.delete(e), e.unregisterTextStreamHandler(l), e.unregisterByteStreamHandler(l);
  }
  return e.once(y.Disconnected, T), {
    messageObservable: g,
    isSendingObservable: v,
    send: C
  };
}
function Bs() {
  const e = (n) => H(null, null, function* () {
    I.info("Start Audio for room: ", n), yield n.startAudio();
  });
  return { className: Y("start-audio-button"), roomAudioPlaybackAllowedObservable: Po, handleStartAudioPlayback: e };
}
function js() {
  const e = (n) => H(null, null, function* () {
    I.info("Start Video for room: ", n), yield n.startVideo();
  });
  return { className: Y("start-audio-button"), roomVideoPlaybackAllowedObservable: Oo, handleStartVideoPlayback: e };
}
function Vs() {
  return { className: [Y("button"), Y("chat-toggle")].join(" ") };
}
function Hs() {
  return { className: [Y("button"), Y("focus-toggle-button")].join(" ") };
}
function zs() {
  return { className: "lk-clear-pin-button lk-button" };
}
function Ys() {
  return { className: "lk-room-container" };
}
function Qt(e, t, n = !0) {
  const i = [e.localParticipant, ...Array.from(e.remoteParticipants.values())], o = [];
  return i.forEach((s) => {
    t.forEach((a) => {
      const c = Array.from(
        s.trackPublications.values()
      ).filter(
        (u) => u.source === a && // either return all or only the ones that are subscribed
        (!n || u.track)
      ).map((u) => ({
        participant: s,
        publication: u,
        source: u.source
      }));
      o.push(...c);
    });
  }), { trackReferences: o, participants: i };
}
function Xt(e, t, n = !1) {
  const { sources: r, kind: i, name: o } = t;
  return Array.from(e.trackPublications.values()).filter(
    (a) => (!r || r.includes(a.source)) && (!i || a.kind === i) && (!o || a.trackName === o) && // either return all or only the ones that are subscribed
    (!n || a.track)
  ).map((a) => ({
    participant: e,
    publication: a,
    source: a.source
  }));
}
function Ks(e, t, n) {
  var r, i;
  const o = (r = n.additionalRoomEvents) != null ? r : Ln, s = (i = n.onlySubscribed) != null ? i : !0, a = Array.from(
    (/* @__PURE__ */ new Set([
      y.ParticipantConnected,
      y.ParticipantDisconnected,
      y.ConnectionStateChanged,
      y.LocalTrackPublished,
      y.LocalTrackUnpublished,
      y.TrackPublished,
      y.TrackUnpublished,
      y.TrackSubscriptionStatusChanged,
      ...o
    ])).values()
  );
  return me(e, ...a).pipe(
    _((u) => {
      const l = Qt(u, t, s);
      return I.debug(`TrackReference[] was updated. (length ${l.trackReferences.length})`, l), l;
    }),
    U(Qt(e, t, s))
  );
}
function qs(e, t) {
  return Te(e, ...ao).pipe(
    _((r) => {
      const i = Xt(r, t);
      return I.debug(`TrackReference[] was updated. (length ${i.length})`, i), i;
    }),
    U(Xt(e, t))
  );
}
function Wn(e, t) {
  return new L((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function Gs(e) {
  return Wn(e, Zt.TranscriptionReceived);
}
function Qs(e) {
  return Wn(e, Zt.TimeSyncUpdate).pipe(
    _(([t]) => t)
  );
}
function Xs(e, t = 1e3) {
  if (e === null) return ht(!1);
  const n = vt(e, "mousemove", { passive: !0 }).pipe(_(() => !0)), r = n.pipe(
    Ai({
      each: t,
      with: () => Ye(ht(!1), r.pipe(Ki(n)))
    }),
    Vi()
  );
  return r;
}
function Uo(e, t) {
  if (typeof localStorage > "u") {
    I.error("Local storage is not available.");
    return;
  }
  try {
    if (t) {
      const n = Object.fromEntries(
        Object.entries(t).filter(([, r]) => r !== "")
      );
      localStorage.setItem(e, JSON.stringify(n));
    }
  } catch (n) {
    I.error(`Error setting item to local storage: ${n}`);
  }
}
function Wo(e) {
  if (typeof localStorage > "u") {
    I.error("Local storage is not available.");
    return;
  }
  try {
    const t = localStorage.getItem(e);
    if (!t) {
      I.warn(`Item with key ${e} does not exist in local storage.`);
      return;
    }
    return JSON.parse(t);
  } catch (t) {
    I.error(`Error getting item from local storage: ${t}`);
    return;
  }
}
function Bo(e) {
  return {
    load: () => Wo(e),
    save: (t) => Uo(e, t)
  };
}
var jo = `${kn}-user-choices`, Pe = {
  videoEnabled: !0,
  audioEnabled: !0,
  videoDeviceId: "default",
  audioDeviceId: "default",
  username: ""
}, { load: Vo, save: Ho } = Bo(jo);
function Js(e, t = !1) {
  t !== !0 && Ho(e);
}
function Zs(e, t = !1) {
  var n, r, i, o, s;
  const a = {
    videoEnabled: (n = e?.videoEnabled) != null ? n : Pe.videoEnabled,
    audioEnabled: (r = e?.audioEnabled) != null ? r : Pe.audioEnabled,
    videoDeviceId: (i = e?.videoDeviceId) != null ? i : Pe.videoDeviceId,
    audioDeviceId: (o = e?.audioDeviceId) != null ? o : Pe.audioDeviceId,
    username: (s = e?.username) != null ? s : Pe.username
  };
  if (t)
    return a;
  {
    const c = Vo();
    return J(J({}, a), c ?? {});
  }
}
var ut = null, lt = null, zo = 0;
function Jt() {
  return ut || (ut = /* @__PURE__ */ new Map()), ut;
}
function Yo() {
  return lt || (lt = /* @__PURE__ */ new WeakMap()), lt;
}
function Ko(e, t) {
  const n = Yo();
  let r = n.get(e);
  return r || (r = `room_${zo++}`, n.set(e, r)), `${r}:${t}`;
}
function ea(e, t) {
  const n = Ko(e, t), r = Jt(), i = r.get(n);
  if (i)
    return i;
  const o = new re();
  let s = [];
  const a = "lk.segment_id", c = o.pipe(
    qi({
      subscribe: () => {
        e.registerTextStreamHandler(t, (u, l) => H(null, null, function* () {
          var f;
          const h = ye(u).pipe(
            Ue((m, p) => m + p, "")
          ), d = !!((f = u.info.attributes) != null && f[a]);
          h.subscribe((m) => {
            const p = s.findIndex(
              (g) => {
                var v, x;
                return g.streamInfo.id === u.info.id || d && ((v = g.streamInfo.attributes) == null ? void 0 : v[a]) === ((x = u.info.attributes) == null ? void 0 : x[a]);
              }
            );
            p !== -1 ? (s[p] = fe(J({}, s[p]), {
              text: m,
              // Carry the latest streamInfo forward. Transcription updates for a
              // segment arrive as separate streams sharing the same lk.segment_id;
              // keeping the original streamInfo would freeze attributes that change
              // over the segment's lifetime — notably lk.transcription_final flipping
              // "false" -> "true" on the final user STT result.
              streamInfo: u.info
            }), o.next([...s])) : (s.push({
              text: m,
              participantInfo: l,
              streamInfo: u.info
            }), o.next([...s]));
          });
        }));
      },
      finalize: () => {
        e.unregisterTextStreamHandler(t);
      }
    }),
    Yi()
  );
  return r.set(n, c), e.on(y.Disconnected, () => {
    Jt().delete(n), s = [], o.next([]);
  }), c;
}
function Bn(e, t) {
  if (t.msg === "show_chat")
    return { ...e, showChat: !0, unreadMessages: 0 };
  if (t.msg === "hide_chat")
    return { ...e, showChat: !1 };
  if (t.msg === "toggle_chat") {
    const n = { ...e, showChat: !e.showChat };
    return n.showChat === !0 && (n.unreadMessages = 0), n;
  } else return t.msg === "unread_msg" ? { ...e, unreadMessages: t.count } : t.msg === "toggle_settings" ? { ...e, showSettings: !e.showSettings } : { ...e };
}
function jn(e, t) {
  return t.msg === "set_pin" ? [t.trackReference] : t.msg === "clear_pin" ? [] : { ...e };
}
const Vn = D.createContext(void 0);
function ta() {
  const e = D.useContext(Vn);
  if (!e)
    throw Error("Tried to access LayoutContext context outside a LayoutContextProvider provider.");
  return e;
}
function na(e) {
  const t = qo();
  if (e ?? (e = t), !e)
    throw Error("Tried to access LayoutContext context outside a LayoutContextProvider provider.");
  return e;
}
function ra() {
  const [e, t] = D.useReducer(jn, Rn), [n, r] = D.useReducer(Bn, Mn);
  return {
    pin: { dispatch: t, state: e },
    widget: { dispatch: r, state: n }
  };
}
function ia(e) {
  const [t, n] = D.useReducer(jn, Rn), [r, i] = D.useReducer(Bn, Mn);
  return e ?? {
    pin: { dispatch: n, state: t },
    widget: { dispatch: i, state: r }
  };
}
function qo() {
  return D.useContext(Vn);
}
const Hn = D.createContext(
  void 0
);
function oa() {
  const e = D.useContext(Hn);
  if (!e)
    throw Error("tried to access track context outside of track context provider");
  return e;
}
function zn() {
  return D.useContext(Hn);
}
function sa(e) {
  const t = zn(), n = e ?? t;
  if (!n)
    throw new Error(
      "No TrackRef, make sure you are inside a TrackRefContext or pass the TrackRef explicitly"
    );
  return n;
}
const Yn = D.createContext(void 0);
function aa() {
  const e = D.useContext(Yn);
  if (!e)
    throw Error("tried to access participant context outside of participant context provider");
  return e;
}
function Go() {
  return D.useContext(Yn);
}
function ca(e) {
  const t = Go(), n = zn(), r = e ?? t ?? n?.participant;
  if (!r)
    throw new Error(
      "No participant provided, make sure you are inside a participant context or pass the participant explicitly"
    );
  return r;
}
const Kn = D.createContext(void 0);
function ua() {
  const e = D.useContext(Kn);
  if (!e)
    throw Error("tried to access room context outside of livekit room component");
  return e;
}
function Qo() {
  return D.useContext(Kn);
}
function la(e) {
  const t = Qo(), n = e ?? t;
  if (!n)
    throw new Error(
      "No room provided, make sure you are inside a Room context or pass the room explicitly"
    );
  return n;
}
const qn = D.createContext(void 0);
function fa() {
  const e = D.useContext(qn);
  if (!e)
    throw Error("tried to access session context outside of SessionProvider component");
  return e;
}
function Xo() {
  return D.useContext(qn);
}
function da(e) {
  const t = Xo(), n = e ?? t;
  if (!n)
    throw new Error(
      "No session provided, make sure you are inside a Session context or pass the session explicitly"
    );
  return n;
}
const Jo = D.createContext(void 0);
function pa(e) {
  const t = D.useContext(Jo);
  if (e === !0) {
    if (t)
      return t;
    throw Error("tried to access feature context, but none is present");
  }
  return t;
}
export {
  Js as $,
  bs as A,
  Go as B,
  _o as C,
  Us as D,
  Os as E,
  na as F,
  fs as G,
  As as H,
  ks as I,
  xs as J,
  Ss as K,
  Jo as L,
  gs as M,
  Bs as N,
  js as O,
  Vs as P,
  Ns as Q,
  Kn as R,
  Is as S,
  Rs as T,
  po as U,
  Ks as V,
  vs as W,
  Gt as X,
  ys as Y,
  Ws as Z,
  Zs as _,
  ta as a,
  Es as a0,
  q as a1,
  qs as a2,
  Qs as a3,
  Gs as a4,
  hs as a5,
  ps as a6,
  Ls as a7,
  fo as a8,
  Ts as a9,
  aa as aA,
  fa as aB,
  oa as aC,
  ea as aa,
  Io as ab,
  Xo as ac,
  da as ad,
  zn as ae,
  Vn as af,
  Fs as ag,
  es as ah,
  Br as ai,
  Yn as aj,
  pa as ak,
  Hn as al,
  Xs as am,
  rs as an,
  ia as ao,
  cs as ap,
  as as aq,
  qn as ar,
  os as as,
  ss as at,
  ds as au,
  ra as av,
  ts as aw,
  is as ax,
  ls as ay,
  us as az,
  zs as b,
  ca as c,
  $s as d,
  ws as e,
  ua as f,
  Mo as g,
  Ds as h,
  sa as i,
  qo as j,
  Hs as k,
  I as l,
  ns as m,
  uo as n,
  Lo as o,
  V as p,
  Ps as q,
  Po as r,
  Ys as s,
  Fn as t,
  la as u,
  _s as v,
  Qo as w,
  Cs as x,
  Ms as y,
  ms as z
};
//# sourceMappingURL=contexts-BtSGUJjc.mjs.map
